import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { selectCurrentDeviceModel, selectCurrentDeviceStatus, selectNewDeviceState0 } from 'src/app/store/device/device.selector';
import { Observable, Subscription, filter } from 'rxjs';
import { Device } from 'src/app/model/device';
import { DeviceState, DeviceStatus } from 'src/app/model/device-status';
import { DeviceModel } from 'src/app/model/device-model';
import { EDeviceModel } from 'src/app/conf/device-models';
import { convertDbStandartIcon, convertOldIcon, DeviceIcon } from 'src/app/conf/device-icons';
import { TranslateService } from '@ngx-translate/core';
import { Thermo } from 'src/app/model/thermo';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectCurrentDeviceThermo } from 'src/app/store/device-th/device-th.selector';

@Component({
	selector: 'app-device-icon',
	templateUrl: './device-icon.component.html',
	providers: [],
})

export class DeviceIconComponent implements OnInit, OnDestroy {
	@Input() device: Device;
	// @Input() standalone: boolean;
	// device$: Observable<Device | undefined>;
	// deviceSub: Subscription | undefined;
	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription | undefined;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;
	deviceState0$: Observable<DeviceState | undefined>;
	deviceState0Sub: Subscription | undefined;

	// device: Device;
	deviceModel: DeviceModel;
	deviceStatus: DeviceStatus;
	iconName: string;

	thermoDevicesSub: Subscription;
	thermo: Thermo;

	isTH = false;
	greenPowerActive = false;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onResize();
	}

	initSelectors(): void {
		// Store selectors
		// this.device$ = this.store.select(selectCurrentDevice);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
		this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
		this.deviceState0$ = this.store.select(selectNewDeviceState0);
	}

	subscribeAll(): void {
		// this.deviceSub = this.device$.pipe(filter(d => !!d))
		// 	.subscribe(device => {
		// 		this.device = device;
		// 	});
		this.deviceState0Sub = this.deviceState0$.pipe(filter(d => !!d))
			.subscribe(deviceState0 => {
				if (deviceState0 !== undefined) {
					this.greenPowerActive = deviceState0.GreenPowerActive;
				}
			});
		this.deviceStatusSub = this.deviceStatus$.pipe(filter(ds => !!ds))
			.subscribe(deviceStatus => {
				this.deviceStatus = deviceStatus;
			});
		this.deviceModelSub = this.deviceModel$.pipe(filter(dm => !!dm))
			.subscribe(deviceModel => {
				this.deviceModel = deviceModel;
				if (deviceModel.CategoryId === 3) {
					this.isTH = true;
				}
				this.generateIcon();
			});
		this.thermoDevicesSub = this.store.select(selectCurrentDeviceThermo).subscribe(
			deviceThermo => {
				if (this.isTH) {
					this.thermo = deviceThermo;
				} else {
					this.thermo = null;
				}
			}
		);
	}

	generateIcon(): void {
		let icon = '';
		if (this.deviceModel.Id !== EDeviceModel.MultiIO) {
			icon = 'cm-' + DeviceIcon[this.deviceModel.Id];
		} else {
			icon = 'cm-' + this.device.IconName.toLowerCase() || 'cm-' + DeviceIcon[this.deviceModel.Id] || 'cm-device-gateway';
		}
		switch (icon) {
			case 'cm-undefined': {
				this.iconName = convertDbStandartIcon(this.deviceModel.IconName);
				break;
			}
			default: {
				this.iconName = convertOldIcon(icon);
				break;
			}
		}
	}

	ngOnDestroy(): void {
		// this.deviceSub?.unsubscribe();
		this.deviceStatusSub?.unsubscribe();
		this.deviceModelSub?.unsubscribe();
		this.thermoDevicesSub?.unsubscribe();
		this.deviceState0Sub?.unsubscribe();
	}

	getStatus(): string {
		if (this.thermo !== undefined && this.thermo !== null) {
			if (this.thermo.error !== null && this.thermo.error !== undefined && this.thermo.error !== "None") {
				return this.translate.instant('GENERIC_ERROR');
			}
			if (this.thermo.on_line !== null && this.thermo.on_line !== undefined && this.thermo.on_line === 1) {
				return this.translate.instant('ONLINE');
			}
			return this.translate.instant('OFFLINE');
		} else {
			if (this.deviceStatus === undefined || !this.deviceStatus.Online) {
				return this.translate.instant('OFFLINE');
			} else if (this.deviceStatus.Errored) {
				return this.translate.instant('GENERIC_ERROR');
			} else {
				return this.translate.instant('ONLINE');
			}
			//return ((this.deviceStatus) ? (this.deviceStatus.Errored) ? this.translate.instant('GENERIC_ERROR') : ((this.deviceStatus.Online) ? this.translate.instant('ONLINE') : this.translate.instant('OFFLINE')) : this.translate.instant('GENERIC_ERROR'));
		}
	}

	getStatusColor(): string {
		if (this.thermo !== undefined && this.thermo !== null) {
			if (this.thermo.error !== null && this.thermo.error !== undefined && this.thermo.error !== "None") {
				return 'warning';
			}
			if (this.thermo.on_line !== null && this.thermo.on_line !== undefined && this.thermo.on_line === 1) {
				return 'success';
			}
			return 'danger';
		} else {
			if (this.deviceStatus === undefined || !this.deviceStatus.Online) {
				return 'danger';
			} else if (this.deviceStatus.Errored) {
				return 'warning';
			} else {
				return 'success';
			}
			//return (this.deviceStatus !== undefined && this.deviceStatus.Errored) ? 'warning' : ((this.deviceStatus !== undefined && this.deviceStatus.Online) ? 'success' : 'danger');
		}
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	/* lenght: could be 'long' or 'short' */
	getTruncate(str: string, lenght: string): string {
		if (this.onExtendedMobile()) {
			return str.slice(0, 15) + (str.length > 15 ? '...' : '');
		}
		return lenght === 'long' ? str.slice(0, 24) + (str.length > 24 ? '...' : '') : str.slice(0, 19) + (str.length > 19 ? '...' : '');
	}
}
